import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const HailITAEXLargeLegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.hail")} (ITA) - ExLarge</b>
      </div>
      <div>
        <span style={legendItemStyle("#f0e5ee")}></span>
        Low: 0 &lt; ph &lt; 0.001
      </div>
      <div>
        <span style={legendItemStyle("#c4adc5")}></span>
        Moderate: 0.001 &le; ph &lt; 0.003
      </div>
      <div>
        <span style={legendItemStyle("#98749c")}></span>
        Significant: 0.003 &le; ph &lt; 0.004
      </div>
      <div>
        <span style={legendItemStyle("#7b4f80")}></span>
        High: ph &gt; 0.004
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          ph = annual probability of extremely large hail (&gt; 50mm diameter)
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default HailITAEXLargeLegend;
